"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBounds = void 0;
/**
 * Get metadata for a set of chart data. Iterates the data exactly once.
 * @internal
 */
var getBounds = function (data) {
    var min = 0;
    var max = 0;
    var maxTooltip = 0;
    data.forEach(function (d) {
        min = d.value < min ? d.value : min;
        max = d.value > max ? d.value : max;
        maxTooltip = d.yLabel.length > maxTooltip ? d.yLabel.length : maxTooltip;
    });
    var result = {
        min: min,
        max: max,
        maxTooltip: maxTooltip,
        range: max - min,
    };
    return result;
};
exports.getBounds = getBounds;
